import { OnFileChangeType } from 'commons/components/input-file-uploader/input-file-uploader.component';
import { useTranslation } from 'core/i18n/i18n';
import { useEapSettingsErrorValidationMessageForm } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/hooks/use-eap-settings-error-validation-message-form/use-eap-settings-error-validation-message-form.hook';
import { useEapSettingsFormValidation } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/hooks/use-eap-settings-validation-form/use-eap-settings-validation-form.hook';
import {
    EapFormCardContent,
    EapFormTitle,
    EapInputFileUploader,
    EapOwcInput,
} from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/settings-devices-eap-settings-form.style';
import { EapSettingsFormProtocolModel } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/components/eap-settings-form-protocol/eap-settings-form-protocol.model';
import { initialEapPeapFormValidation } from './eap-settings-form-peap-protocol.constants';
import { withOptionalLabel } from 'commons/utils/optional-label.utils';

interface EapSettingsFormPeapProps {
    data: EapSettingsFormProtocolModel;
    onDataChange?: <K extends keyof EapSettingsFormProtocolModel>(
        propertyName: K,
        value: EapSettingsFormProtocolModel[K]
    ) => void;
}

export const EapSettingsFormPeap = ({ data, onDataChange }: EapSettingsFormPeapProps) => {
    const { eapSettingsFormValidatorError, handleError, handlePasswordError } =
        useEapSettingsFormValidation(initialEapPeapFormValidation);
    const { errorMessages } = useEapSettingsErrorValidationMessageForm();
    const { t } = useTranslation();
    return (
        <EapFormCardContent>
            <div>
                <EapFormTitle>
                    {withOptionalLabel(
                        t,
                        t('settings.devices.eap-settings.eap-config-create-form.form.field.ca-certificate')
                    )}
                </EapFormTitle>
                <EapInputFileUploader
                    textButton={t('settings.devices.eap-settings.eap-config-create-form.button.browse')}
                    onFileChange={(value: OnFileChangeType) => {
                        onDataChange?.('caCertificateFilename', value.fileName);
                        onDataChange?.('caCertificate', value.file);
                    }}
                    dataTestId="ca-certificate"
                    fileName={data.caCertificateFilename}
                    placeholder={t(
                        'settings.devices.eap-settings.eap-config-create-form.form.field.ca-certificate.placeholder'
                    )}
                />
            </div>
            <div>
                <EapFormTitle>
                    {t('settings.devices.eap-settings.eap-config-create-form.form.field.username')}
                </EapFormTitle>
                <EapOwcInput
                    name="username"
                    onChange={(_, value) => onDataChange?.('username', value as string)}
                    value={data.username}
                    placeholder={t(
                        'settings.devices.eap-settings.eap-config-create-form.form.field.username.placeholder'
                    )}
                    required
                    type="text"
                    validity={eapSettingsFormValidatorError.username}
                    onValidity={(_, val) => handleError('username', val)}
                    validationMessages={errorMessages.username}
                />
            </div>
            <div>
                <EapFormTitle>
                    {t('settings.devices.eap-settings.eap-config-create-form.form.field.password')}
                </EapFormTitle>
                <EapOwcInput
                    name="password"
                    onChange={(_, value) => {
                        onDataChange?.('password', value as string);
                        handlePasswordError({
                            password: value as string,
                            confirmPassword: data.confirmPassword,
                        });
                    }}
                    value={data.password}
                    placeholder={t(
                        'settings.devices.eap-settings.eap-config-create-form.form.field.password.placeholder'
                    )}
                    required
                    type="password"
                    validity={eapSettingsFormValidatorError.password}
                    onValidity={(_, val) => handleError('confirmPassword', val)}
                    validationMessages={errorMessages.password}
                />
            </div>
            <div>
                <EapFormTitle>
                    {t('settings.devices.eap-settings.eap-config-create-form.form.field.password-confirm')}
                </EapFormTitle>
                <EapOwcInput
                    name="passwordConfirm"
                    onChange={(_, value) => {
                        onDataChange?.('confirmPassword', value as string);
                        handlePasswordError({
                            password: data.password,
                            confirmPassword: value as string,
                        });
                    }}
                    value={data.confirmPassword}
                    placeholder={t(
                        'settings.devices.eap-settings.eap-config-create-form.form.field.password-confirm.placeholder'
                    )}
                    required
                    type="password"
                    validity={eapSettingsFormValidatorError.confirmPassword}
                    validationMessages={errorMessages.confirmPassword}
                />
            </div>
        </EapFormCardContent>
    );
};
